// name to be displayed for extension downloads
export const SITE_GAME_NAME = "Tools & Extensions";
// delay for hover effects (e.g. submenus opening on hover) that would otherwise
// be frustrating or irritating
export const HOVER_DELAY = 500;
